import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, CalendarDays } from "lucide-react";
import api from "../lib/api";
import SmartImage from "../components/SmartImage";
import Breadcrumbs from "../components/Breadcrumbs";
import { EmptyState, SkeletonGrid } from "../components/States";
import { formatDate } from "../lib/format";

export default function Blog() {
  const [posts, setPosts] = useState(null);

  useEffect(() => {
    api
      .get("/posts")
      .then((r) => setPosts(r.data.posts || []))
      .catch(() => setPosts([]));
  }, []);

  return (
    <div data-testid="blog-page">
      <section className="border-b" style={{ borderColor: "rgba(255,255,255,0.08)", background: "var(--nq-ink)" }}>
        <div className="container-nq py-10">
          <Breadcrumbs items={[{ slug: "blog", label: "Blog" }]} />
          <p className="eyebrow mt-4">News &amp; advice</p>
          <h1 className="mt-2 text-3xl font-bold md:text-5xl">Blog</h1>
        </div>
      </section>

      <div className="container-nq section-nq">
        {!posts ? (
          <SkeletonGrid count={3} />
        ) : posts.length === 0 ? (
          <EmptyState title="No posts yet" />
        ) : (
          <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3" data-testid="blog-grid">
            {posts.map((p) => (
              <article key={p.slug} className="card-nq group flex flex-col" data-testid="blog-card">
                <Link to={`/${p.slug}`} className="block overflow-hidden">
                  <SmartImage
                    src={p.image}
                    alt={p.title}
                    ratio="aspect-[16/10]"
                    fit="cover"
                    fallbackLabel={p.title}
                    className="transition-transform duration-500 group-hover:scale-[1.04]"
                  />
                </Link>
                <div className="flex flex-1 flex-col p-5">
                  {p.date && (
                    <p className="flex items-center gap-1.5 text-xs text-[color:var(--nq-stone)]">
                      <CalendarDays className="h-3.5 w-3.5 gold-text" /> {formatDate(p.date)}
                    </p>
                  )}
                  <h2 className="mt-2 text-lg font-semibold leading-snug">
                    <Link to={`/${p.slug}`} className="transition hover:text-[color:var(--nq-gold)]">
                      {p.title}
                    </Link>
                  </h2>
                  <p className="mt-2 line-clamp-3 flex-1 text-sm text-[color:var(--nq-stone)]">{p.excerpt}</p>
                  <Link
                    to={`/${p.slug}`}
                    className="mt-4 flex items-center gap-1.5 text-xs font-semibold gold-text"
                  >
                    Read article <ArrowRight className="h-3.5 w-3.5" />
                  </Link>
                </div>
              </article>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
